import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-ricorso-opposizione-view',
  templateUrl: './form-ricorso-opposizione-view.component.html',
  styleUrls: ['./form-ricorso-opposizione-view.component.css']
})
export class FormRicorsoOpposizioneViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
